module.exports = __webpack_public_path__ + "media/images/countryrect/fk-1f8677b834cd271ac1aa48e0bf2e0521.svg";